import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "dashboard",
      component: () => import("./views/Dashboard.vue"),
    },
    {
      path: "/contracts",
      component: () => import("./views/Contracts/Contracts.vue"),
      children: [
        {
          path: "new",
          component: () => import("./views/Contracts/Pages/NewContract.vue"),
          meta: { path: 'Contratos:Nuevo', action: 'Page:view' }
        },
        {
          path: "all",
          component: () => import("./views/Contracts/Pages/AllContracts.vue"),
          meta: { path: 'Contratos:Todos', action: 'Page:view' }
        },
      ],
    },
    {
      path: "/employees",
      component: () => import("./views/Employees/Employees.vue"),
      children: [
        {
          path: "all",
          component: () => import("./views/Employees/Pages/AllEmployee.vue"),
          meta: { path: 'Empleados:Todos', action: ['Page:view', 'Page:viewOwn'] }
        },
        {
          path: "mine",
          component: () => import("./views/Employees/Pages/MineEmployee.vue"),
          meta: { path: 'Empleados:Propios', action: 'Page:view' }
        },
        {
          path: "overtime",
          component: () =>
            import("./views/Employees/Pages/OvertimeEmployee.vue"),
          meta: { path: 'Empleados:HorasExtra', action: 'Page:view' }
        },
        {
          path: "personal-actions",
          component: () =>
            import("./views/Employees/Pages/PersonalActionEmployee.vue"),
          meta: { path: 'Empleados:Acciones', action: 'Page:view' }
        },
        {
          path: "trainings",
          component: () =>
            import("./views/Employees/Pages/Trainings.vue"),
          meta: { path: 'Empleados:Capacitaciones', action: 'Page:view' }
        },
      ],
    },
    {
      path: "/paysheet",
      component: () => import("./views/Paysheet/Paysheet.vue"),
      children: [
        {
          path: "all",
          component: () => import("./views/Paysheet/Pages/AllPaysheets.vue"),
          meta: { path: 'Nomina:Todas', action: 'Page:view' }
        },
        {
          path: "overtime",
          component: () =>
            import("./views/Paysheet/Pages/OvertimePaysheet.vue"),
          meta: { path: 'Nomina:HorasExtra', action: 'Page:view' }
        },
        {
          path: "actions",
          component: () => import("./views/Paysheet/Pages/ActionsPaysheet.vue"),
          meta: { path: 'Nomina:Acciones', action: 'Page:view' }
        },
        {
          path: "historic",
          component: () =>
            import("./views/Paysheet/Pages/HistoricPaysheets.vue"),
          meta: { path: 'Nomina:Historica', action: 'Page:view' }
        },
      ],
    },
    {
      path: "/settings",
      component: () => import("./views/Settings/Settings.vue"),
      children: [
        {
          path: "documents",
          component: () => import("./views/Settings/Pages/Documents.vue"),
          meta: { path: 'Configuraciones:Documentos', action: 'Page:view' }
        },
        {
          path: "contracts",
          component: () => import("./views/Settings/Pages/Contracts.vue"),
          meta: { path: 'Configuraciones:Contratos', action: 'Page:view' }
        },
        {
          path: "banks",
          component: () => import("./views/Settings/Pages/Banks.vue"),
          meta: { path: 'Configuraciones:Bancos', action: 'Page:view' }
        },
        {
          path: "job-positions",
          component: () => import("./views/Settings/Pages/JobPositions.vue"),
          meta: { path: 'Configuraciones:Puestos', action: 'Page:view' }
        },
        {
          path: "organization",
          component: () =>
            import("./views/Settings/Pages/DepartmensPositions.vue"),
          meta: { path: 'Configuraciones:Organizacion', action: 'Page:view' }
        },
        {
          path: "universities",
          component: () =>
            import("./views/Settings/Pages/InstitutionsStudies.vue"),
          meta: { path: 'Configuraciones:Instituciones', action: 'Page:view' }
        },
        {
          path: "actions",
          component: () => import("./views/Settings/Pages/Actions.vue"),
          meta: { path: 'Configuraciones:Acciones', action: 'Page:view' }
        },
        {
          path: "discounts",
          component: () => import("./views/Settings/Pages/Discounts.vue"),
          meta: { path: 'Configuraciones:Descuentos', action: 'Page:view' }
        },
      ],
    },
    {
      path: "/access",
      component: () => import("./views/Access/Access.vue"),
      children: [
        {
          path: "users",
          component: () => import("./views/Access/Pages/Usersv.vue"),
          meta: { path: 'Accesos:Usuarios', action: 'Page:view' }
        },
      ],
    },
    {
      path: "/reports",
      component: () => import("./views/Reports/Reports.vue"),
      children: [
        {
          path: "remployees",
          component: () => import("./views/Reports/Pages/Employees.vue"),
          meta: { path: 'Reportes:Empleados', action: 'Page:view' }
        },
        {
          path: "rgeneral",
          component: () => import("./views/Reports/Pages/General.vue"),
          meta: { path: 'Reportes:Generales', action: 'Page:view' }
        },
        {
          path: "rplanilla",
          component: () => import("./views/Reports/Pages/Planilla.vue"),
          meta: { path: 'Reportes:Planillas', action: 'Page:view' }
        },
      ],
    },
  ],
});
